import axios from 'axios';

import url from './baseURL';

//const token = localStorage.getItem("tokenMinu");


const api = axios.create({
    baseURL: url.api,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        'Accept': 'application/json',
    }
});

// Interceptor → ajoute le token à chaque requête
api.interceptors.request.use(config => {
    const token = localStorage.getItem("tokenMinu")
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

export default api;